<template>
<div class="chapter">
<div class="inner_page">
<div id="Abbreviations">
<p class="ch-title"><a id="page_6"><b>ABBREVIATIONS</b></a></p><a id="page_6">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"><p class="abb-para">BEC:</p></td>
<td valign="top"><p class="abb-para">British Electric Car Co Ltd</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">BET:</p></td>
<td valign="top"><p class="abb-para">British Electric Traction</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">BTC:</p></td>
<td valign="top"><p class="abb-para">British Transport Commission</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">EMB:</p></td>
<td valign="top"><p class="abb-para">Electro-Magnetic Brake Co</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">ER&amp;TCW:</p></td>
<td valign="top"><p class="abb-para">Electric Railway &amp; Tramway Carriage Works Co</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">GNP:</p></td>
<td valign="top"><p class="abb-para">Glasgow Numerical Printing Co</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">LMS:</p></td>
<td valign="top"><p class="abb-para">London, Midland &amp; Scottish Railway</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">LNER:</p></td>
<td valign="top"><p class="abb-para">London &amp; North Eastern Railway</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">LPTB</p></td>
<td valign="top"><p class="abb-para">London Passenger Transport Board</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">LT:</p></td>
<td valign="top"><p class="abb-para">London Transport</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">LUT:</p></td>
<td valign="top"><p class="abb-para">London United Tramways</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">M&amp;G:</p></td>
<td valign="top"><p class="abb-para">Mountain &amp; Gibson Ltd</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">M&amp;T:</p></td>
<td valign="top"><p class="abb-para">Maley &amp; Taunton Ltd</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">MET:</p></td>
<td valign="top"><p class="abb-para">Metropolitan Electric Tramways</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">PCC:</p></td>
<td valign="top"><p class="abb-para">Presidents’ Conference Car</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">UDC:</p></td>
<td valign="top"><p class="abb-para">Urban District Council</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">UEC:</p></td>
<td valign="top"><p class="abb-para">United Electric Car Co Ltd</p></td>
</tr>
<tr>
<td valign="top"><p class="abb-para">VAMBAC:</p></td>
<td valign="top"><p class="abb-para">variable automatic multi-notch braking and control</p></td>
</tr>
</tbody>
</table>
<div class="box">
<p class="box-title">KEY TO MAPS</p>
<p class="box-para"><img alt="" class="mi" src="images/map_key1.jpg"/>   Passenger lines</p>
<p class="box-para"><img alt="" class="mi" src="images/map_key2.jpg"/>   Lines closed before 1 January 1945</p>
<p class="box-para"><img alt="" class="mi" src="images/map_key3.jpg"/>   Non-passenger lines</p>
<p class="box-para"><img alt="" class="mi" src="images/map_key4.jpg"/>   Lines of neighbouring operators – open at 1 January 1945</p>
<p class="box-para"><img alt="" class="mi" src="images/map_key5.jpg"/>   Lines of neighbouring operators – closed at 1 January 1945</p>
<p class="box-para"><img alt="" class="mi" src="images/map_key6.jpg"/>   Passenger lines built opened after 1 January 1945</p>
<p class="box-para"><img alt="" class="mi" src="images/map_key7.jpg"/>   Lines under construction at 1 January 1945 – never completed</p>
</div>
</a></div><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Abbreviations.vue?43f10cda